import { queryKeysFactory } from '@lib/query-key-factory'

const CARTS_QUERY_KEY = 'carts' as const
export const cartsQueryKeys = queryKeysFactory(CARTS_QUERY_KEY)
